class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
      const nextElementToFocus = event.target.closest('.mp-parent-display').querySelector('.mp-show-more-item')
      if (nextElementToFocus && !nextElementToFocus.classList.contains('mp-hidden')) {
        nextElementToFocus.querySelector('input').focus()
      }
    });
  }
  expandShowMore(event) {
    const parentDisplay = event.target.closest('[id^="mp-Show-More-"]').closest('.mp-parent-display');
    const parentWrap = parentDisplay.querySelector('.mp-parent-wrap');
    this.querySelectorAll('.mp-label-text').forEach(element => element.classList.toggle('mp-hidden'));
    parentDisplay.querySelectorAll('.mp-show-more-item').forEach(item => item.classList.toggle('mp-hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);

